import { render, staticRenderFns } from "./BookingChat.vue?vue&type=template&id=b944a820"
import script from "./BookingChat.vue?vue&type=script&lang=js"
export * from "./BookingChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports